// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

const { Types, Creators } = createActions({
  getPromoSectionRequest: ['data'],
  getPromoSectionSuccess: ['data'],
  getPromoSectionFailure: ['err'],

  updatePromoSectionRequest: ['data'],
  updatePromoSectionSuccess: ['data'],
  updatePromoSectionFailure: ['err'],
})

export const PromoSectionTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  fetching: false,
  data: {},
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, success: null})

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })

export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })

export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null})

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PROMO_SECTION_SUCCESS]: success,
  [Types.GET_PROMO_SECTION_REQUEST]: request,
  [Types.GET_PROMO_SECTION_FAILURE]: failure,

  [Types.UPDATE_PROMO_SECTION_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_PROMO_SECTION_REQUEST]: manipulateRequest,
  [Types.UPDATE_PROMO_SECTION_FAILURE]: manipulateFailure,
})



// WEBPACK FOOTER //
// ./src/Redux/PromoSectionRedux.js